import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

// Обычный хост, без авторизации
const $host = axios.create({
    baseURL
});

// Хост с авторизацией
const $authHost = axios.create({
    baseURL
});

// Интерсептор для подстановки JWT токена
$authHost.interceptors.request.use(config => {
    const token = localStorage.getItem('token'); // читаем токен из localStorage
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Интерсептор для обработки ошибок
const errorHandler = (error) => {
    if (error.response) {
        const data = error.response.data;
        return Promise.reject({
            status: error.response.status,
            code: data?.code || 'UNKNOWN_ERROR',
            message: data?.message || 'Server error'
        });
    }

    if (error.request) {
        return Promise.reject({
            status: null,
            message: 'Server is not responding'
        });
    }

    return Promise.reject({
        status: null,
        message: error.message || 'Unexpected error'
    });
};

$authHost.interceptors.response.use(res => res, errorHandler);

export {
    $host,
    $authHost
};